 import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom"; // 🔥 useNavigate added
import { useEffect, useState } from "react";
import { connectSocket, getSocket } from "./socket";

import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyOtp from "./pages/VerifyOtp";
import PaymentSuccess from "./pages/PaymentSuccess";
import Earnings from "./pages/MyEarnings"; // 🔥 New Earnings Page

import Profile from "./pages/Profile";
import Home from "./pages/Home";
import AddItem from "./pages/AddItem";
import MyItems from "./pages/MyItems";
import ItemDetail from "./pages/ItemDetail";
import BorrowSummary from "./pages/BorrowSummary";
import ReturnSummary from "./pages/ReturnSummary";
import PickupItem from "./pages/PickupItem";

import ChatPage from "./pages/ChatPage";
import ChatList from "./pages/ChatList";

import Handover from "./pages/Handover"; 
import AdminDashboard from "./pages/AdminDashboard";

import ProtectedRoute from "./routes/ProtectedRoute";
import MyEarnings from "./pages/MyEarnings";

function App() {
  const [notifications, setNotifications] = useState([]);
  const [search, setSearch] = useState("");
  const [user, setUser] = useState(null); // 🔥 Added User State

  const location = useLocation();
  const navigate = useNavigate(); // 🔥 Added Navigation Hook

  /* ==================================================
      🔥 1. AUTO-LOGIN LOGIC (YE MISSING THA)
  ================================================== */
  useEffect(() => {
    // Check LocalStorage when App starts
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (storedUser && token) {
      // Restore User Session
      setUser(JSON.parse(storedUser));
      connectSocket(token); // Connect Socket immediately if logged in

      // Agar logged in banda Login/Register pe hai, toh Home bhejo
      if (location.pathname === "/login" || location.pathname === "/register" || location.pathname === "/") {
        navigate("/home");
      }
    } else {
      // Agar Token nahi hai, aur wo Protected Route pe jane ki koshish kare
      const publicPages = ["/login", "/register", "/forgot-password", "/reset-password", "/verify-otp", "/"];
      if (!publicPages.includes(location.pathname)) {
         navigate("/login");
      }
    }
  }, [navigate]); // Run once on mount

  /* ---------------- CONNECT SOCKET ON APP LOAD (Modified) ---------------- */
  // Note: Upar wale Auto-Login effect mein connectSocket call kar diya hai, 
  // lekin safety ke liye ye wala rehne de sakte hain agar user state change ho.
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      connectSocket(token);
    }
  }, []);

  /* ---------------- SOCKET CONNECT LOG ---------------- */
  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const onConnect = () => {
      console.log("🟢 Socket connected:", socket.id);
    };

    socket.on("connect", onConnect);
    return () => socket.off("connect", onConnect);
  }, []);

  /* ---------------- RECEIVE NOTIFICATIONS ---------------- */
  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handler = (data) => {
      console.log("🔔 New notification:", data);
      // Agar banda Chat Page par hai, toh notification mat dikhao (optional logic)
      if (location.pathname.startsWith("/chat/")) return;
      setNotifications((prev) => [...prev, data]);
    };

    socket.on("newNotification", handler);
    return () => socket.off("newNotification", handler);
  }, [location.pathname]);

  const clearNotifications = () => {
    setNotifications([]);
  };

  return (
    <>
      <Routes>
        {/* AUTH (Public Routes) */}
        <Route path="/" element={<Navigate to="/register" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />

        {/* PROTECTED ROUTES (Login Required) */}
        
        {/* HOME */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home search={search} />
            </ProtectedRoute>
          }
        />

        <Route path="/profile" element={<Profile />} />

        {/* CHAT LIST */}
        <Route
          path="/chats"
          element={
            <ProtectedRoute>
              <ChatList />
            </ProtectedRoute>
          }
        />
        
        {/* CHAT PAGE */}
        <Route
          path="/chat/:conversationId"
          element={
            <ProtectedRoute>
              <ChatPage clearNotifications={clearNotifications} />
            </ProtectedRoute>
          }
        />

        {/* ITEMS */}
        <Route
          path="/add-item"
          element={
            <ProtectedRoute>
              <AddItem />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-item/:id"
          element={
            <ProtectedRoute>
              <AddItem />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-items"
          element={
            <ProtectedRoute>
              <MyItems />
            </ProtectedRoute>
          }
        />

        {/* HANDOVER & ADMIN */}
        <Route 
          path="/handover" 
          element={
            <ProtectedRoute>
              <Handover />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
                <AdminDashboard />
            </ProtectedRoute>
          } 
        />

        {/* ITEM DETAILS & BORROWING */}
        <Route path="/items/:id" element={<ItemDetail />} />

        <Route
          path="/borrow/:id"
          element={
            <ProtectedRoute>
              <BorrowSummary />
            </ProtectedRoute>
          }
        />

        <Route
          path="/return-summary"
          element={
            <ProtectedRoute>
              <ReturnSummary />
            </ProtectedRoute>
          }
        />

        <Route path="/pickup-item" element={<PickupItem />} />
        
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/earnings" element={<MyEarnings />} /> {/* 🔥 New Earnings Route */}

      </Routes>
    </>
  );
}

export default App;